"use client"

import { useLocation, useNavigate } from "react-router"

import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsTriggerIcon,
  TabsTriggerLabel,
} from "@/components/ui/tabs"
import {
  STUDENT_EXXAT_ONE_TABS,
  studentExxatOneTabFromPath,
} from "@/lib/student-exxat-one-utility-bar"
import { cn } from "@/lib/utils"

/**
 * Home · Schedule · Jobs — center line tabs on the student Exxat One utility bar.
 */
export function UtilityBarStudentOneTabs({ className }: { className?: string }) {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const activeTab = studentExxatOneTabFromPath(pathname)

  const handleChange = (next: string) => {
    const tab = STUDENT_EXXAT_ONE_TABS.find(entry => entry.id === next)
    if (tab) navigate(tab.href)
  }

  return (
    <div
      data-slot="utility-bar-student-one-tabs"
      className={cn(
        "pointer-events-none absolute inset-x-0 flex h-full justify-center px-2",
        className,
      )}
    >
      <Tabs
        value={activeTab}
        onValueChange={handleChange}
        className="pointer-events-auto flex h-full items-center"
      >
        <TabsList
          ariaLabel="Exxat One"
          variant="line"
          collapseLabels={false}
          className="h-full w-fit justify-center border-none bg-transparent"
        >
          {STUDENT_EXXAT_ONE_TABS.map(tab => (
            <TabsTrigger
              key={tab.id}
              value={tab.id}
              className="min-h-9 flex-none gap-2 px-3"
            >
              <TabsTriggerIcon>
                <i
                  className={cn("fa-light", tab.icon, "text-sm")}
                  aria-hidden="true"
                />
              </TabsTriggerIcon>
              <TabsTriggerLabel>{tab.label}</TabsTriggerLabel>
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  )
}
